// extracted by mini-css-extract-plugin
module.exports = {"app-logo":"style_app-logo__3QQJN"};